export const ClockIcon = () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.18034 2.66665C5.23482 2.66665 2.84701 5.05446 2.84701 7.99998C2.84701 10.9455 5.23482 13.3333 8.18034 13.3333C11.1259 13.3333 13.5137 10.9455 13.5137 7.99998C13.5137 5.05446 11.1259 2.66665 8.18034 2.66665ZM1.51367 7.99998C1.51367 4.31808 4.49844 1.33331 8.18034 1.33331C11.8622 1.33331 14.847 4.31808 14.847 7.99998C14.847 11.6819 11.8622 14.6666 8.18034 14.6666C4.49844 14.6666 1.51367 11.6819 1.51367 7.99998ZM8.18034 3.99998C8.54853 3.99998 8.84701 4.29846 8.84701 4.66665V7.72384L10.6517 9.52858C10.9121 9.78893 10.9121 10.211 10.6517 10.4714C10.3914 10.7317 9.96928 10.7317 9.70893 10.4714L7.70893 8.47138C7.58391 8.34636 7.51367 8.17679 7.51367 7.99998V4.66665C7.51367 4.29846 7.81215 3.99998 8.18034 3.99998Z"
                fill="#A5AAAF"
            />
        </svg>
    );
};
